import { createAction, props } from '@ngrx/store'
import { Catalogue } from '../../models/catalogue'

export const catalogueRequested = createAction('[Catalogue] get', props<{ hrid: string }>())
export const catalogueRetrieved = createAction('[Catalogue] retrieved', props<{ hrid: string; catalogue: Catalogue }>())
export const catalogueRequestFailed = createAction('[Catalogue] request failed', props<{ hrid: string }>())
export const catalogueModified = createAction('[Catalogue] modified', props<{ id: number }>())
